module.exports = __webpack_public_path__ + "static/media/save.6786bfb8.png";